import React from "react";
import "./AvatarDialog.scss";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";

import { Avatars } from "../../api/ReplayVariables";

function AvatarDialog({ show, handleClose, onAvatarSelected }) {
  const { t } = useTranslation();

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      dialogClassName="avatar-dialog"
    >
      <Modal.Header closeButton closeLabel={false}>
        <Modal.Title>{t("settings.avatar")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PerfectScrollbar>
          <div className="avatars">
            {letters.map((letter) => (
              <div
                key={letter}
                className="img-container"
                onClick={() => {
                  onAvatarSelected(letter);
                }}
              >
                <img src={Avatars["avatar" + letter.toUpperCase()]} alt="" />
              </div>
            ))}
          </div>
        </PerfectScrollbar>
      </Modal.Body>
    </Modal>
  );
}

export default AvatarDialog;
